<div class="talent-job-opportunities">
  <nz-page-header class="large p-l-8 p-r-0">
    <nz-page-header-title>{{ "talent.job-opportunities.title" | translate }}</nz-page-header-title>
  </nz-page-header>

  <!-- Filters Section -->
  <div class="filters-section" [formGroup]="filterForm">
    <nz-card class="filters-card">
      <div nz-row [nzGutter]="[16, 16]">
        <div nz-col [nzSpan]="24" [nzMd]="8">
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                formControlName="searchTerm"
                [placeholder]="'talent.job-opportunities.filters.search.placeholder' | translate"
                (keyup.enter)="submitFilterForm()"
              />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="24" [nzMd]="8">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                formControlName="sector"
                [nzPlaceHolder]="'talent.job-opportunities.filters.sector.placeholder' | translate"
                nzAllowClear
              >
                <nz-option
                  *ngFor="let sector of sectors$ | async"
                  [nzLabel]="sector.name | translate"
                  [nzValue]="sector"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="24" [nzMd]="8">
          <nz-form-item>
            <nz-form-control>
              <nz-select
                formControlName="industry"
                [nzPlaceHolder]="'talent.job-opportunities.filters.industry.placeholder' | translate"
                nzAllowClear
              >
                <nz-option
                  *ngFor="let industry of industries$ | async"
                  [nzLabel]="industry.name | translate"
                  [nzValue]="industry"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="filter-actions">
        <button nz-button nzType="primary" (click)="submitFilterForm()">
          {{ "talent.job-opportunities.filters.search.button" | translate }}
        </button>
      </div>
    </nz-card>
  </div>

  <!-- Job Opportunities List -->
  <div class="job-opportunities-section">
    <nz-spin [nzSpinning]="loading">
      <div class="card-list">
        <div
          class="card-list__item"
          *ngFor="let jobOpportunity of filteredJobOpportunities"
          [attr.data-job-id]="jobOpportunity.jobOpportunityId"
        >
          <div class="card-list__body" (click)="onStartConversation(jobOpportunity)">
            <div nz-row>
              <div nz-col [nzSpan]="24">
                <div class="job-offer job-offer--in-list">
                  <div nz-row [nzGutter]="[16, 16]" class="job-offer__details">
                    <div nz-col [nzSpan]="24">
                      <div class="job-offer__header">
                        <div class="job-offer__header-row">
                          <div class="job-offer__header-col">
                            <div class="job-offer__name">
                              {{ jobOpportunity.jobOpportunityName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="jobOpportunity.description" nz-col [nzSpan]="24">
                      <div class="job-offer__field job-offer__description-wrap">
                        <div class="job-offer__value job-offer__description job-offer__description--h-auto">
                          <div
                            class="description-text"
                            [class.description-text--clamped]="!isDescriptionExpanded(jobOpportunity.jobOpportunityId)"
                          >
                            {{ jobOpportunity.description }}
                          </div>
                          <button
                            *ngIf="shouldShowMoreButton(jobOpportunity.jobOpportunityId)"
                            nz-button
                            nzType="link"
                            nzSize="small"
                            class="description-toggle-btn"
                            (click)="
                              toggleDescriptionExpansion(jobOpportunity.jobOpportunityId); $event.stopPropagation()
                            "
                          >
                            {{
                              isDescriptionExpanded(jobOpportunity.jobOpportunityId)
                                ? ("less.button" | translate)
                                : ("more.button" | translate)
                            }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="24" [nzMd]="6" *ngIf="jobOpportunity.sectorFocus?.length">
                      <div class="job-offer__field">
                        <div class="job-offer__title">{{ "job-offer-matches.detail.sector.label" | translate }}</div>
                        <mh-tags-output [value]="jobOpportunity.sectorFocus"></mh-tags-output>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="24" [nzMd]="6" *ngIf="jobOpportunity.industries?.length">
                      <div class="job-offer__field">
                        <div class="job-offer__title">
                          {{ "job-offer-matches.detail.industries.label" | translate }}
                        </div>
                        <mh-tags-output [value]="jobOpportunity.industries"></mh-tags-output>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="24" [nzMd]="6" *ngIf="jobOpportunity.domainExpertise?.length">
                      <div class="job-offer__field">
                        <div class="job-offer__title">
                          {{ "job-offer-matches.list.domain-expertise.title" | translate }}
                        </div>
                        <mh-tags-output [value]="jobOpportunity.domainExpertise"></mh-tags-output>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="24" [nzMd]="6" *ngIf="jobOpportunity.department?.length">
                      <div class="job-offer__field">
                        <div class="job-offer__title">
                          {{ "job-offer-matches.detail.department.label" | translate }}
                        </div>
                        <mh-tags-output [value]="jobOpportunity.department"></mh-tags-output>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="24" [nzMd]="6" *ngIf="jobOpportunity.careerLevel?.length">
                      <div class="job-offer__field">
                        <div class="job-offer__title">{{ "profile.career-level.label" | translate }}</div>
                        <mh-tags-output [value]="jobOpportunity.careerLevel"></mh-tags-output>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="24" [nzMd]="6" *ngIf="jobOpportunity.locations?.length">
                      <div class="job-offer__field">
                        <div class="job-offer__title">{{ "job-offer-matches.list.location.title" | translate }}</div>
                        <mh-view-job-offer-location
                          [jobOffer]="asJobOffer(jobOpportunity)"
                        ></mh-view-job-offer-location>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="24" [nzMd]="6" *ngIf="jobOpportunity.workingModes?.length">
                      <div class="job-offer__field">
                        <div class="job-offer__title">{{ "job-offer-matches.detail.mode.label" | translate }}</div>
                        <mh-tags-output [value]="jobOpportunity.workingModes"></mh-tags-output>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-list__actions">
            <button
              nz-button
              nzType="link"
              [nz-tooltip]="
                jobOpportunity.conversationId
                  ? ('conversation.go-to.tooltip' | translate)
                  : ('conversation.start.tooltip' | translate)
              "
              (click)="onStartConversation(jobOpportunity, $event)"
            >
              <span nz-icon nzType="send" nzTheme="outline"></span>
            </button>
          </div>
        </div>

        <nz-empty *ngIf="!filteredJobOpportunities.length" nzNotFoundImage="simple"></nz-empty>
      </div>

      <!-- Pagination -->
      <div *ngIf="!loading && totalItems > pageSize" class="pagination-section">
        <nz-pagination
          [nzPageIndex]="currentPage"
          [nzPageSize]="pageSize"
          [nzTotal]="totalItems"
          [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="[10, 20, 50]"
          (nzPageIndexChange)="onPageChange($event)"
          (nzPageSizeChange)="onPageSizeChange($event)"
        >
        </nz-pagination>
      </div>
    </nz-spin>
  </div>
</div>
